import { Box, Stack } from '@mui/material';
import { MOBILE_NAV_ITEMS } from 'config/mobileNavConfig';
import React, { createContext, useContext, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import MobileAppBar from '../AppBar';
import MobileSidebar from '../Sidebar';

export interface MobileLayoutContextValue {
  setHideAppBarMenu: (hide: boolean) => void;
}

const MobileLayoutContext = createContext<MobileLayoutContextValue | null>(
  null,
);

export const useMobileLayout = (): MobileLayoutContextValue => {
  const ctx = useContext(MobileLayoutContext);
  if (ctx == null) return { setHideAppBarMenu: () => {} };
  return ctx;
};

const MobileLayout: React.FC = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [hideAppBarMenu, setHideAppBarMenu] = useState(false);
  const navigate = useNavigate();

  const handleMenuClick = () => {
    setDrawerOpen((prev) => !prev);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handleNavItemClick = (path: string) => {
    navigate(path);
  };

  return (
    <MobileLayoutContext.Provider value={{ setHideAppBarMenu }}>
      <Stack
        direction="column"
        sx={{
          height: '100dvh',
          maxHeight: '100vh',
          overflow: 'hidden',
        }}
      >
        <MobileAppBar
          onMenuClick={handleMenuClick}
          sidebarOpen={drawerOpen}
          hideMenuButton={hideAppBarMenu}
        />
        <Box
          component="main"
          sx={{
            flex: 1,
            minHeight: 0,
            overflow: 'auto',
            backgroundColor: 'background.paper',
            px: 2,
            position: 'relative',
          }}
        >
          <Outlet />
          <MobileSidebar
            open={drawerOpen}
            onClose={handleDrawerClose}
            items={MOBILE_NAV_ITEMS}
            onItemClick={handleNavItemClick}
          />
        </Box>
      </Stack>
    </MobileLayoutContext.Provider>
  );
};

export default MobileLayout;
